__turbopack_context__.v({
  "additional": "benefitsSection-module-scss-module__5TZSyW__additional",
  "additionalContent": "benefitsSection-module-scss-module__5TZSyW__additionalContent",
  "benefitIcon": "benefitsSection-module-scss-module__5TZSyW__benefitIcon",
  "benefitName": "benefitsSection-module-scss-module__5TZSyW__benefitName",
  "cell": "benefitsSection-module-scss-module__5TZSyW__cell",
  "cellContainer": "benefitsSection-module-scss-module__5TZSyW__cellContainer",
  "container": "benefitsSection-module-scss-module__5TZSyW__container",
  "gridContainer": "benefitsSection-module-scss-module__5TZSyW__gridContainer",
  "hasBasicBenefits": "benefitsSection-module-scss-module__5TZSyW__hasBasicBenefits",
  "heading": "benefitsSection-module-scss-module__5TZSyW__heading",
  "noAdditional": "benefitsSection-module-scss-module__5TZSyW__noAdditional",
});
